export const isDef = <T>(val: T | undefined): val is T => val !== undefined;

export const isNotNull = <T>(val: T | null): val is T => val !== null;

export const isDefAndNotNull = <T>(val: T | null | undefined): val is T => val !== undefined && val !== null;
